import { createContext, useContext } from 'react';
import { UseQueryResult } from 'react-query';
import { StaffMember } from '@/types/api/staffMember';

type PTORequestsContext = {
  fetchStaffMembers: Record<string, UseQueryResult<StaffMember>>;
};

const context = createContext<PTORequestsContext>({
  fetchStaffMembers: {},
});

export const usePTORequestsPageContext = (): PTORequestsContext => useContext(context);

export default context;
